export default __webpack_public_path__ + "locales/pl/InviteDialog.json?hash=19b7195181a07945c6b1c0e80de2ce4d";